import { __decorate, __metadata } from "tslib";
import { Fingerprintable, instanceToPlainWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { PromotionExposeGroup } from '../interface';
import { ReadPromotionDto } from './ReadPromotionDto';
import { ReadValidationReasonDto } from './ReadValidationReasonDto';
let ReadPromoCodeWithApplicationStateDto = class ReadPromoCodeWithApplicationStateDto {
    getFingerprint() {
        return instanceToPlainWithLVS(this, { groups: [PromotionExposeGroup.PROFILER] });
    }
};
__decorate([
    ApiPropertyOptional({ type: () => ReadPromotionDto }),
    Expose({ groups: [PromotionExposeGroup.READ] }),
    Type(() => ReadPromotionDto),
    __metadata("design:type", ReadPromotionDto)
], ReadPromoCodeWithApplicationStateDto.prototype, "promotion", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PROFILER] }),
    __metadata("design:type", Boolean)
], ReadPromoCodeWithApplicationStateDto.prototype, "isApplied", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PROFILER] }),
    __metadata("design:type", Boolean)
], ReadPromoCodeWithApplicationStateDto.prototype, "isApplicable", void 0);
__decorate([
    ApiProperty({ type: () => ReadValidationReasonDto, isArray: true }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PROFILER] }),
    Type(() => ReadValidationReasonDto),
    __metadata("design:type", Array)
], ReadPromoCodeWithApplicationStateDto.prototype, "validationReasons", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 1 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PROFILER] }),
    __metadata("design:type", Number)
], ReadPromoCodeWithApplicationStateDto.prototype, "availableApplicationCount", void 0);
ReadPromoCodeWithApplicationStateDto = __decorate([
    Fingerprintable()
], ReadPromoCodeWithApplicationStateDto);
export { ReadPromoCodeWithApplicationStateDto };
//# sourceMappingURL=ReadPromoCodeWithApplicationStateDto.js.map